import React, { useEffect, useState, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";
import { FaArrowLeft, FaPrint } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import supergitHIS from "../api/supergitHIS";
import QRCode from "react-qr-code";
import moment from "moment";
import { amountToArabicWords, amountToWords } from "./AmountToWord";
import { formatDate } from "../Pages/Transactions/TransactionsTable";
import validSupergitHIS from "../api/validSupergitHIS";

const ThirdPartyRevokeInvoice = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const iframeRef = useRef(null);
  const invoiceRef = useRef(null);
  const { clientOrderID } = useParams();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const location = useLocation();
  const status = location?.state?.status;
  const module = location?.state?.module;
  const invoiceData = location?.state?.invoiceData;
  const revoke = location?.state?.revoke;
  const invoiceType = invoiceData?.InsuranceCompanyName
    ? "insurance"
    : "cash" || "cash";

  const url = location?.state?.url;
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await validSupergitHIS.get(`${url}/${clientOrderID}`);
      setData(response.data);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [clientOrderID]);

  // --- FIX APPLIED IN THIS FUNCTION ---
  const handlePrint = () => {
    const printContents = invoiceRef.current.innerHTML;
    const iframe = iframeRef.current;
    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write("<html><head><title>Invoice</title>");
    doc.write(`
      <html>
        <head>
          <title>Invoice</title>
           <script src="https://cdn.tailwindcss.com"></script>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            .zatca-invoice { max-width: 800px; margin: auto; }
          </style>
        </head>
        <body dir="ltr">
          ${printContents}
        </body>
      </html>
    `);
    doc.close();
    iframe.onload = () => {
      iframe.contentWindow.print();
    };
  };

  return (
    <div>
      <div>
        <div className="flex gap-3">
          <Button
            onClick={() =>
              navigate("/zatca/thirdparty", {
                state: { activeTab: module, childIndex: revoke ? 1 : 0 },
              })
            }
            variant="contained"
            style={{
              backgroundImage:
                "linear-gradient(83deg, #f14f3e 0%, #fab768 100%)",
            }}
            className="bg-[#0070C2] border-[#0070C2] shadow-[#0070C2] hover:border-[#0070C2]"
            startIcon={<FaArrowLeft />}
            size="small"
          >
            {t("Back")}
          </Button>
          {status === "REPORTED" && (
            <Button
              onClick={handlePrint}
              variant="contained"
              style={{
                backgroundImage:
                  "linear-gradient(83deg, #f14f3e 0%, #fab768 100%)",
              }}
              startIcon={<FaPrint />}
              className="bg-[#0070C2] border-[#0070C2] shadow-[#0070C2] hover:border-[#0070C2] focus:border-[#0070C2]"
              size="small"
            >
              {t("PrintInvoice")}
            </Button>
          )}
        </div>
      </div>
      {/* --- FIX APPLIED IN THIS DIV --- */}
      <div
        dir="ltr"
        ref={invoiceRef}
        className="max-w-4xl mx-auto bg-white flex items-center justify-center zatca-invoice"
      >
        <div className="w-full flex flex-col mt-4 px-0">
          <div className="border-2 border-[#333]">
            {invoiceData?.StoreID === 3 || invoiceData?.StoreID === 4 ? (
              <div className="w-full flex items-center justify-between p-2 border-2 border-b-[#333]">
                <div className="flex flex-col ">
                  <h3 className="text-[#0070C0] font-bold text-[16px] text-center">
                    Hossam Company <br />
                    Factory for industry
                  </h3>
                  <div className="mt-3">
                    <p className="text-[12px] font-[400] text-[#212529]">
                      C.R:   <span>1010611152</span>
                    </p>
                  </div>
                  <div>
                    <p className="text-[12px] font-[400] text-[#212529]">
                      VAT NO:   <span>300928379600003</span>
                    </p>
                  </div>
                </div>

                <div>
                  <img
                    src="/images/hussam_logo.jpeg"
                    className="w-[220px] h-[100px]"
                    alt="logo"
                  />
                </div>

                <div className="flex flex-col text-center">
                  <h3 className="text-[#0070C0] font-bold text-[16px]">
                    مصنع شركة حسام للصناعه
                  </h3>
                  <div className="mt-3">
                    <p className="text-[12px] font-[400] text-[#212529]">
                      س ت:   <span>1010611152</span>
                    </p>
                  </div>
                  <div>
                    <p className="text-[12px] font-[400] text-[#212529]">
                      الرقم الضريبي:   <span>300928379600003</span>
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              <div className="w-full flex items-center justify-between p-2 border-2 border-b-[#333]">
                <div className="flex flex-col ">
                  <h3 className="text-[#0070C0] font-bold text-[16px] text-center">
                    HUSSAM COMPANY LTD <br />
                    OPTICAL DIVISION
                  </h3>
                  <div className="mt-3">
                    <p className="text-[12px] font-[400] text-[#212529]">
                      C.R:   <span>4030056116</span>
                    </p>
                  </div>
                  <div>
                    <p className="text-[12px] font-[400] text-[#212529]">
                      VAT NO:   <span>300928379600003</span>
                    </p>
                  </div>
                </div>

                <div>
                  <img
                    src="/images/hussam_logo.jpeg"
                    className="w-[220px] h-[100px]"
                    alt="logo"
                  />
                </div>

                <div className="flex flex-col text-center">
                  <h3 className="text-[#0070C0] font-bold text-[16px]">
                    شـــــركة حســـــام المحدودة <br />
                    قسم البصريات
                  </h3>
                  <div className="mt-3">
                    <p className="text-[12px] font-[400] text-[#212529]">
                      س ت:   <span>4030056116</span>
                    </p>
                  </div>
                  <div>
                    <p className="text-[12px] font-[400] text-[#212529]">
                      الرقم الضريبي:   <span>300928379600003</span>
                    </p>
                  </div>
                </div>
              </div>
            )}

            <div className="flex flex-col p-0 border-2 border-b-[#333]">
              <div className="flex flex-col gap-2 items-center border-b-2 border-[#385d8a]  py-3">
                <div className="flex items-center justify-between w-full">
                  {/* Barcode on the left */}
                  <div className="w-1/3 flex flex-col items-start">
                    <img
                      class="tax-code-image"
                      src="data:image/png;base64,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"
                      alt="tax-code"
                    />
                    <div className="text-[10px] mt-1">
                      {invoiceData?.NoteSerial}
                    </div>
                  </div>
                  {/* Center-aligned title */}
                  <div className="w-1/3 flex justify-center">
                    <div className="border-2 border-[#385d8a] rounded-2xl px-4 py-2">
                      <h3 className="font-bold text-[16px] text-center">
                        {revoke
                          ? "Credit Note إشعار دائن"
                          : data?.[0]?.transaction_type_code?.startsWith("01")
                            ? "Tax Invoice فاتورة ضريبية"
                            : "Simplified Tax Invoice فاتورة ضريبية مبسطة"}
                      </h3>
                    </div>
                  </div>

                  {/* Empty space for alignment */}
                  <div className="w-1/3"></div>
                </div>
                <div className="flex items-center justify-between w-full px-2 gap-4">
                  {/* LOCAL SERIAL */}
                  <p className="text-[12px] font-[400] text-[#212529] text-center">
                    {invoiceData?.LocalSerial}{" "}
                  </p>

                  {/* Inv # Label */}
                  <p className="text-[12px] font-[400] text-[#212529]">
                    {revoke ? "Credit # :" : "Inv # :"}
                  </p>

                  {/* Invoice Number (Red & Bold) */}
                  <p className="text-[20px] font-[700] text-red-600 text-center">
                    {data?.revoke?.InvoiceId}
                  </p>

                  {/* Arabic Label */}
                  <p className="text-[12px] ar font-semibold text-right">
                    {revoke ? "رقم الإشعار الدائن :" : "رقم الفاتورة :"}
                  </p>
                </div>
              </div>
              <div class="table-responsive mt-2 p-2">
                <table class="w-full">
                  <tbody>
                    <tr>
                      <td class="text-[12px] font-[400] text-[#212529]">
                        Date:{" "}
                      </td>
                      <td class="text-[12px] font-[400] text-[#212529] text-center">
                        {moment(data?.revoke?.RevokeDate).format(
                          "DD-MM-YYYY hh:mm A"
                        )}
                      </td>
                      <td class="text-[12px] font-[400] text-[#212529] ar">
                        التاريخ :
                      </td>
                    </tr>
                    <tr>
                      <td class="text-[12px] font-[400] text-[#212529]">
                        Branch :{" "}
                      </td>
                      <td class="text-[12px] font-[400] text-[#212529] text-center">
                        {invoiceData?.GalleryName}
                        {invoiceData?.StoreName}{" "}
                      </td>
                      <td class="text-[12px] font-semibold text-[#212529] ar ">
                        اسم الفرع :{" "}
                      </td>
                      <td class="text-[12px] font-[400] text-[#212529]">
                        Tel. # of Branch :{" "}
                      </td>
                      <td class="text-[12px] font-[400] text-[#212529] text-center">
                        {invoiceData?.GalleryPhones} {invoiceData?.Phone}{" "}
                      </td>
                      <td class="text-[12px] font-semibold text-[#212529] ar">
                        رقم هاتف الفرع :{" "}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="flex flex-col p-2 border-2 border-b-[#333]">
              <div className="grid grid-cols-3">
                <p class="text-[12px] font-[400] text-[#212529]">
                  Customer Name :{" "}
                </p>
                <p class="text-[12px] font-[400] text-[#212529] text-center">
                  {data?.revoke?.CustomerName}
                </p>
                <p class="text-[12px] ar font-semibold">اسم العميل :</p>
              </div>
              <div className="grid grid-cols-3">
                <p class="text-[12px] font-[400] text-[#212529]">Mobile # </p>
                <p class="text-[12px] font-[400] text-[#212529] text-center">
                  {invoiceData?.InsuranceCustomerMobile}{" "}
                  {invoiceData?.FirstPhone}{" "}
                </p>
                <p class="text-[12px] ar font-semibold">رقم جوال العميل</p>
              </div>
            </div>
            {invoiceType !== "cash" && (
              <div className="flex flex-col p-2 border-2 border-b-[#333]">
                <div className="grid grid-cols-3">
                  <p class="text-[12px] font-[400] text-[#212529]">
                    INSURANCE CO.{" "}
                  </p>
                  <p class="text-[12px] font-[400] text-[#212529] text-center">
                    {invoiceData?.SubHolder} {invoiceData?.InsuranceCompanyName}{" "}
                  </p>
                  <p class="text-[12px] ar font-semibold">شركة التأمين</p>
                </div>
                <div className="grid grid-cols-3">
                  <p class="text-[12px] font-[400] text-[#212529]">
                    VAT NO FOR INSURANCE CO.{" "}
                  </p>
                  <p class="text-[12px] font-[400] text-[#212529] text-center">
                    {" "}
                    {invoiceData?.InsuranceCompanyTax}
                  </p>
                  <p class="text-[12px] ar font-semibold">
                    الرقم الضريبي لشركة التأمين :
                  </p>
                </div>
                <div className="grid grid-cols-3">
                  <p class="text-[12px] font-[400] text-[#212529]">
                    Membership #{" "}
                  </p>
                  <p class="text-[12px] font-[400] text-[#212529] text-center">
                    {" "}
                    {invoiceData?.InsuredNo}
                  </p>
                  <p class="text-[12px] ar font-semibold">رقم عضوية العميل</p>
                </div>
                <div className="grid grid-cols-3">
                  <p class="text-[12px] font-[400] text-[#212529]">
                    Company Name:{" "}
                  </p>
                  <p class="text-[12px] font-[400] text-[#212529] text-center">
                    {" "}
                    {invoiceData?.InsuranceCompanyName}{" "}
                  </p>
                  <p class="text-[12px] ar font-semibold">اسم الشركة:</p>
                </div>
              </div>
            )}

            <div class="table-responsive ">
              <table class="w-full">
                <thead className="border-2 border-b-[#333]">
                  <tr>
                    <th scope="col" className="border-r-2 border-[#333] px-2">
                      <span className="block text-[12px] font-semibold">
                        رقم الصنف
                      </span>
                      <span className="block text-[12px] font-semibold">
                        Code
                      </span>
                    </th>
                    <th scope="col" className="border-r-2 border-[#333] px-2">
                      <span className="block text-[12px] font-semibold">
                        البيـــــــــــان{" "}
                      </span>
                      <span className="block text-[12px] font-semibold">
                        Description{" "}
                      </span>
                    </th>
                    <th scope="col" className="border-r-2 border-[#333] px-2">
                      <span className="block text-[12px] font-semibold">
                        الكمــيــة
                      </span>
                      <span className="block text-[12px] font-semibold">
                        Qty.{" "}
                      </span>
                    </th>
                    <th scope="col" className="border-r-2 border-[#333] px-2">
                      <span className="block text-[12px] font-semibold">
                        ســعـر الـوحــدة{" "}
                      </span>
                      <span className="block text-[12px] font-semibold">
                        Unit Price{" "}
                      </span>
                    </th>
                    <th scope="col" className="border-r-2 border-[#333] px-2">
                      <span className="block text-[12px] font-semibold">
                        الإجمالي{" "}
                      </span>
                      <span className="block text-[12px] font-semibold">
                        Total
                      </span>
                    </th>
                    <th scope="col" className="border-r-2 border-[#333] px-2">
                      <span className="block text-[12px] font-semibold">
                        الخصم{" "}
                      </span>
                      <span className="block text-[12px] font-semibold">
                        Disc.
                      </span>
                    </th>
                    <th scope="col" className="border-r-2 border-[#333] px-2">
                      <span className="block text-[12px] font-semibold">
                        المبلغ الخاضع للضريبة
                      </span>
                      <span className="block text-[12px] font-semibold"></span>
                    </th>
                    <th scope="col" className="border-r-2 border-[#333] px-2">
                      <span className="block text-[12px] font-semibold">
                        VAT%
                      </span>
                      <span className="block text-[12px] font-semibold"></span>
                    </th>
                    <th scope="col" className="border-r-2 border-[#333] px-2">
                      <span className="block text-[12px] font-semibold">
                        VAT Amount
                      </span>
                      <span className="block text-[12px] font-semibold"></span>
                    </th>
                    <th scope="col" className="px-2">
                      <span className="block text-[12px] font-semibold">
                        الصافي شامل الضريبة
                      </span>
                      <span className="block text-[12px] font-semibold">
                        Net Value
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.details &&
                    data?.details?.map((data, index) => {
                      const quantity = Number(data?.Quantity) || 0;
                      const netPrice = Number(data?.NetPrice) || 0;
                      const priceDiscount = Number(data?.Discount) || 0;

                      const totalPrice = netPrice + priceDiscount;
                      const unitPrice =
                        quantity !== 0 ? totalPrice / quantity : 0;
                      const grossTotal = unitPrice * quantity;
                      const netTotal = grossTotal - priceDiscount;

                      return (
                        <tr key={index}>
                          <td className="text-[12px] font-[400] px-2 text-center border-r-2 border-[#333]">
                            {data?.ProductCode}
                          </td>
                          <td className="text-[12px] font-[400] px-2 text-center border-r-2 border-[#333]">
                            {data?.Description}
                          </td>
                          <td className="text-[12px] font-[400] px-2 text-center border-r-2 border-[#333]">
                            {data?.Quantity}
                          </td>
                          <td className="text-[12px] font-[400] px-2 text-center border-r-2 border-[#333]">
                            {data?.UPrice?.toFixed(2)}
                          </td>
                          <td className="text-[12px] font-[400] px-2 text-center border-r-2 border-[#333]">
                            {data?.TPrice?.toFixed(2)}
                          </td>
                          <td className="text-[12px] font-[400] px-2 text-center border-r-2 border-[#333]">
                            {data?.Discount?.toFixed(2)}
                          </td>
                          <td className="text-[12px] font-[400] px-2 text-center border-r-2 border-[#333]">
                            {data?.TPrice?.toFixed(2)}
                          </td>
                          <td className="text-[12px] font-[400] px-2 text-center border-r-2 border-[#333]">
                            0
                          </td>
                          <td className="text-[12px] font-[400] px-2 text-center border-r-2 border-[#333]">
                            0.00
                          </td>
                          <td className="text-[12px] font-[400] px-2 text-center">
                            {data?.NetPrice?.toFixed(2)}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
          {(() => {
            const details = data?.[0]?.details
              ? JSON.parse(data[0].details)
              : [];

            const calculatedValues = details.map((item) => {
              const quantity = Number(item?.quantity) || 0;
              const netPrice = Number(item?.net_price) || 0;
              const priceDiscount = Number(item?.price_discount) || 0;
              const tax = Number(item?.tax) || 0;

              const totalPrice = netPrice + priceDiscount;
              const unitPrice = quantity !== 0 ? totalPrice / quantity : 0;
              const grossTotal = unitPrice * quantity;
              const netTotal = grossTotal - priceDiscount;
              const netWithVat = netTotal + tax;

              return { grossTotal, priceDiscount, netTotal, netWithVat };
            });

            const totals = calculatedValues.reduce(
              (acc, curr) => ({
                grossTotal: acc.grossTotal + curr.grossTotal,
                priceDiscount: acc.priceDiscount + curr.priceDiscount,
                netTotal: acc.netTotal + curr.netTotal,
                netWithVat: acc.netWithVat + curr.netWithVat,
              }),
              { grossTotal: 0, priceDiscount: 0, netTotal: 0, netWithVat: 0 }
            );

            return (
              <div className="grid grid-cols-12 gap-x-4 mt-2">
                <div className="col-span-5 border-2 border-[#333] px-2 py-4">
                  <div className="flex items-center justify-between">
                    <p className="text-[12px] font-[400] text-[#212529] capitalize">
                      Net Amount :
                      <span className="mx-1">
                        {amountToWords(data?.revoke?.RevokeAmount?.toFixed(2))}
                      </span>
                      Saudi Riyal
                    </p>
                  </div>
                  <div
                    className="flex items-center"
                    style={{ direction: "rtl" }}
                  >
                    <p className="text-[12px] text-[#212529] font-semibold ar">
                      المبلغ الصافي :
                    </p>
                    <p>
                      <span className="mx-1 me-2">
                        {amountToArabicWords(
                          data?.revoke?.RevokeAmount?.toFixed(2)
                        )}
                      </span>
                      ريال سعودي
                    </p>
                  </div>
                </div>

                <div className="col-span-2">
                  {data?.[0]?.qr_code && (
                    <QRCode
                      size={256}
                      style={{
                        height: "auto",
                        maxWidth: "100%",
                        width: "100%",
                      }}
                      value={`${data[0].qr_code}`}
                      viewBox={`0 0 256 256`}
                    />
                  )}
                </div>

                <div className="col-span-5 border-2 border-[#333] px-2 py-4">
                  <div className="flex items-center w-full">
                    <p className="text-[12px] font-[400] text-[#212529] w-[100px]">
                      Total Price
                    </p>
                    <p className="text-[12px] ar font-semibold">إجمالى السعر</p>
                    <p className="text-[12px] font-[400] text-[#212529] flex-1 text-right">
                      {data?.revoke?.RevokeAmountBeforeDiscount?.toFixed(2)}
                    </p>
                  </div>
                  <div className="flex items-center w-full">
                    <p className="text-[12px] font-[400] text-[#212529] w-[100px]">
                      Discount
                    </p>
                    <p className="text-[12px] ar font-semibold">الخصم</p>
                    <p className="text-[12px] font-[400] text-[#212529] flex-1 text-right">
                      {data?.revoke?.Discount?.toFixed(2)}
                    </p>
                  </div>
                  <div className="flex items-center w-full">
                    <p className="text-[12px] font-[400] text-[#212529] w-[100px]">
                      Net Price
                    </p>
                    <p className="text-[12px] ar font-semibold">
                      الصافي بعد الخصم
                    </p>
                    <p className="text-[12px] font-[400] text-[#212529] flex-1 text-right">
                      {data?.revoke?.RevokeAmount?.toFixed(2)}
                    </p>
                  </div>
                  <div className="flex items-center w-full">
                    <p className="text-[12px] font-[400] text-[#212529] w-[100px]">
                      Net Price with Vat
                    </p>
                    <p className="text-[12px] ar font-semibold">
                      الصافي شامل القيمة المضافة
                    </p>
                    <p className="text-[12px] font-[400] text-[#212529] flex-1 text-right">
                      {data?.revoke?.RevokeAmount?.toFixed(2)}
                    </p>
                  </div>
                </div>
              </div>
            );
          })()}

          <p className="font-semibold text-[12px] my-1 text-[#0070C0] text-right">
            تنبيه هام : الفرع غير مسئول عن النظارة أو العدسات اللاصقة التي لم
            يستلمها صاحبها خلال شهرين من تاريخه
          </p>
          <div class="grid grid-cols-2 gap-x-4 border-b-2 border-b-[#333]">
            <div class="flex items-center justify-between text-[12px] font-[400]">
              <span>Recived By:</span>
              <span>{data?.revoke?.CustomerName}</span>
              <span class="ar font-semibold">توقيع المستلم: </span>
            </div>
            <div class="flex items-center justify-between text-[12px] font-[400]">
              <span>Prepared By:</span>
              {invoiceData?.SalesPerson} {invoiceData?.EmployeeName} {""}
              <span class="ar font-semibold">تم الاعداد بواسطة :</span>
            </div>
          </div>
          <footer class="ar text-[12px] mt-1 font-semibold text-center ">
            <p class="mb-0">
              المملكة العربية السعودية - جده هاتف ( 012/6658665 – 012/6674241 –
              012/6657805 ) – فاكس ( 012/6606675 ) ص ب (10401) جده (21433) -
              اشتراك الغرفة التجارية (17272)
            </p>
            <div class="email">
              <span>الموقع الالكتروني</span>
              <a
                class="text-[#0070C0] text-decoration-none"
                href="mailto:hussamltd.com"
              >
                hussamltd.com
              </a>
              <span>-</span>
              <span>البريد الإلكتروني</span>
              <a
                class="text-[#0070C0] text-decoration-none"
                href="mailto:info@hussamoptics.com"
              >
                (info@hussamoptics.com)
              </a>
            </div>
          </footer>
        </div>
      </div>
      <iframe
        ref={iframeRef}
        style={{ display: "none" }}
        title="Print Invoice"
      ></iframe>
    </div>
  );
};

export default ThirdPartyRevokeInvoice;